<!-- 帮助文档 -->
<template>
  <div class="HelpBox">
		<Nav />
		<div class="Help">
			<div class="banner">
        <h1 class="wow animate__animated animate__rollIn ">步峰代理帮助文档</h1>
        <h3 class="wow animate__animated animate__rollIn ">关注用户体验 提升服务价值</h3>
      </div>
			<div class="_cont">
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane 
					v-for="(item, index) in tabTitleList"
					:key="index"
					:label="item.name" 
					:name="`${index}`" 
					class="_fClass"
					>
						<template>
							<div>
								<el-tabs tab-position="left" style="">
									<el-tab-pane 
									v-for="(items, indexs) in item.articles"
									:key="indexs"
									:label="items.title"
									>
										<div class="_html" v-html="items.content">
										</div>
									</el-tab-pane>
								</el-tabs>
							</div>
						</template>
					</el-tab-pane>
					<!-- <el-tab-pane label="配置管理" name="second">配置管理</el-tab-pane>
					<el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
					<el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane> -->
				</el-tabs>
			</div>
		</div>
		<Foot />
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import { WOW } from 'wowjs' 
import Foot from '@/components/Foot.vue'
import { request } from "../css/request.js";
import { Apis } from "../css/Api.js";
export default {
	name: 'Help',
  components: {
    Nav,
    Foot
	},
	data(){
		return {
			activeName: '0',
			tabTitleList:[],
		}
	},
	created(){
		this.getHelpData()
		
	},
	methods:{
		handleClick(tab, event) {
		},
		getHelpData(){
			let data ={
				category_id :7
			}
			request({
				method: "get", 
				url: Apis.readArticlesList,
				params:data,
				_type:1,
			}).then(res => {
				if(res.code == 0){
					this.tabTitleList = res.data
					this.activeName = '0'
				}else{
					this.$message.error(res.msg);
				}
			});
		}
	}
}
</script>

<style lang="less" scoped>
.HelpBox{
	width: 100%;
	.Help{
		width: 100%;
		.banner{
			width: 100%;
			height: 400px;
			background: url('../assets/banner_2.png')no-repeat;
			background-size: 100% 100%;
			h1,h3{
				width: 100%;
				color: #fff;
				text-align: center;  
				text-shadow: -2px 2px 0px #2a4fe4;
			}
			h1{
				font-size: 48px;
				font-weight: bold;
				padding-top: 130px;
			}
			// h3{
			//   top: 23%;
			// }
		}
		._cont{
			width: 1200px;
			margin: 0 auto;
			._html{
				text-align: left;
				padding-left: 20px;
			}
		}
	}
}
</style>
<style scoped>
.HelpBox >>> .is-top .el-tabs__item{
	font-size: 18px;
	margin: 10px 0;
}
</style>